import { useState } from "react";
import { auth } from "../firebase/config";
import {
  signInWithEmailAndPassword,
  sendEmailVerification,
} from "firebase/auth";
import posthog from 'posthog-js';

function SendVerificationEmail() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");

    try {
      // First sign in the user
      const userCredential = await signInWithEmailAndPassword(
        auth,
        email,
        password,
      );

      // Send verification email
      await sendEmailVerification(userCredential.user);

      setMessage("Verification email sent! Please check your inbox.");
      setEmail("");
      setPassword("");
    } catch (error) {
      console.error("Error:", error);
      posthog.captureException(error, {
        tags: {
          service: 'send_verification_email_page',
          operation: 'send_verification_email',
          user_email: email
        }
      });
      setMessage("Error: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        maxWidth: "400px",
        margin: "40px auto",
        padding: "20px",
        backgroundColor: "white",
        borderRadius: "8px",
        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
      }}
    >
      <h2 style={{ textAlign: "center", marginBottom: "20px" }}>
        Send Verification Email
      </h2>

      {message && (
        <div
          style={{
            padding: "10px",
            marginBottom: "20px",
            borderRadius: "4px",
            backgroundColor: message.includes("Error") ? "#fee2e2" : "#f0fdf4",
            color: message.includes("Error") ? "#dc2626" : "#059669",
            border: `1px solid ${message.includes("Error") ? "#fecaca" : "#86efac"}`,
          }}
        >
          {message}
        </div>
      )}

      <form onSubmit={handleSubmit}>
        <div style={{ marginBottom: "15px" }}>
          <label style={{ display: "block", marginBottom: "5px" }}>Email</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            style={{
              width: "100%",
              padding: "8px",
              borderRadius: "4px",
              border: "1px solid #ddd",
            }}
          />
        </div>

        <div style={{ marginBottom: "20px" }}>
          <label style={{ display: "block", marginBottom: "5px" }}>
            Password
          </label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            style={{
              width: "100%",
              padding: "8px",
              borderRadius: "4px",
              border: "1px solid #ddd",
            }}
          />
        </div>

        <button
          type="submit"
          disabled={loading}
          style={{
            width: "100%",
            padding: "10px",
            backgroundColor: loading ? "#d1d5db" : "#ffa600",
            color: "white",
            border: "none",
            borderRadius: "4px",
            cursor: loading ? "not-allowed" : "pointer",
            transition: "background-color 0.2s",
          }}
        >
          {loading ? "Sending..." : "Send Verification Email"}
        </button>
      </form>
    </div>
  );
}

export default SendVerificationEmail;
